import React from "react";
import { motion } from "framer-motion";
import { FaPhoneAlt, FaEnvelope, FaPlaneDeparture } from "react-icons/fa";

const fadeIn = {
  hidden: { opacity: 0, y: 30 },
  visible: (i = 1) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.15,
      duration: 0.5,
      ease: "easeOut",
    },
  }),
};

const FlightBooking = () => {
 return (
    <div className="max-w-screen-xl mt-44 mb-20 mx-auto py-16 px-6 md:px-20">
      {/* Heading */}
      <motion.h1
        initial="hidden"
        animate="visible"
        variants={fadeIn}
        className="text-4xl font-bold text-center text-yellow-600 mb-12"
      >
        ✈️ Book Your Flight with Ease
      </motion.h1>

      {/* Intro / Theory */}
      <motion.div
        initial="hidden"
        animate="visible"
        custom={1}
        variants={fadeIn}
        className="text-center max-w-3xl mx-auto text-gray-700 text-lg leading-relaxed mb-16"
      >
        Booking flights has never been simpler. Whether you're planning a quick business trip or a long-awaited vacation, our platform offers smooth, hassle-free flight reservations. Choose from multiple airlines, flexible timings, and competitive prices tailored to your needs. Your journey begins here — safe, comfortable, and convenient.
      </motion.div>

      {/* Why Book With Us Cards */}
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeIn}
        custom={2}
        className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 text-center mb-20"
      >
        {[
          { icon: "🛫", title: "Multiple Airlines", desc: "Access a wide range of airlines and routes worldwide." },
          { icon: "💰", title: "Best Price Guarantee", desc: "Find competitive fares and exclusive discounts." },
          { icon: "📅", title: "Flexible Booking", desc: "Easy date changes and cancellation options." },
          { icon: "⚡", title: "Instant Confirmation", desc: "Get immediate booking confirmation on all flights." },
          { icon: "📞", title: "24/7 Customer Support", desc: "Assistance whenever you need it, day or night." },
          { icon: "🌐", title: "User-Friendly Platform", desc: "Smooth booking experience on all devices." },
        ].map((item, index) => (
          <motion.div
            key={index}
            custom={index + 3}
            variants={fadeIn}
            className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition duration-300"
          >
            <div className="text-4xl mb-3">{item.icon}</div>
            <h3 className="font-semibold text-xl text-yellow-600 mb-2">{item.title}</h3>
            <p className="text-gray-600">{item.desc}</p>
          </motion.div>
        ))}
      </motion.div>

      {/* Contact / Enquiry Section */}
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        custom={10}
        variants={fadeIn}
        className="bg-yellow-100 p-10 rounded-2xl shadow-lg"
      >
        <h2 className="text-2xl font-bold text-yellow-700 mb-6 text-center">📞 For Flight Booking Enquiries</h2>
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 text-center text-gray-800 text-lg">
          <div className="flex items-center justify-center space-x-3">
            <FaPhoneAlt className="text-yellow-600" />
            <span>+91 9327953295 / +91 6377659957</span>
          </div>
          <div className="flex items-center justify-center space-x-3">
            <FaEnvelope className="text-yellow-600" />
            <span>contact@vamikatours.com</span>
          </div>
          <div className="flex items-center justify-center space-x-3">
            <FaPlaneDeparture className="text-yellow-600" />
            <span>123 Airport Road, City, Country</span>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default FlightBooking